import React, { Component } from 'react';
import WeeklyCharts from './WeeklyCharts'
import YearlyCharts from './YearlyCharts'
import './App.css';

class App extends Component {

  render() {
    return (
      <div className="App">
        <main className="container">
          <div className="row my-3">
            <div className="col-lg-12">
              <WeeklyCharts></WeeklyCharts>
            </div>
          </div>

        </main>
      </div>
    );
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js